import { StructuredAddress } from '../types/Logistics';

export const formatStructuredAddress = (
  structuredAddress: StructuredAddress,
  includeCountry = true
) => {
  const { addressLine1, postalCode, city, country } = structuredAddress;
  return `${addressLine1}, ${postalCode} ${city}, ${includeCountry && country}`;
};
